import { JsonDoc } from "./json-doc.model";
/**
 * User class
 */
export class User extends JsonDoc {
  public firstName: string | null;
  public lastName: string | null;
  public email: string | null;
  public uid: string | null;

  constructor(
    firstName?: string,
    lastName?: string,
    email?: string,
    uid?: string,
    docId?: string
  ) {
    if (docId) super(docId);
    else super();
    if (firstName) this.firstName = firstName;
    if (lastName) this.lastName = lastName;
    if (email) this.email = email;
    if (uid) this.uid = uid;
  }
}
